module.exports = __webpack_public_path__ + "static/media/super-premium.4c8e592f.svg";